import { useApiFetcherSWR } from "hooks/SwrCustom";


export const API_ENDPOINT = {


    COMMUNITY_DATA: (communityId) => ({
        url: `weekstaten/samenstellen?iCommunityId=${communityId}`,
        method: "get",
    }),

    SCHOOL_LIST: (id) => ({
        url: `weekstaten/samenstellen/school-list/${id}`,
        method: "get",
    }),

    SAVE_WEEKSTAAT_SCHOOLS: {
        url: "weekstaten/samenstellen",
        method: "post",
    },

    GENERATE_PDF: {
        url: "weekstaten/generate-pdf",
        method: "get",
    },

    WEEKLY_SCHEDULE_LIST: {
        url: "weekstaten/samenstellen/get-Weekly-schedule-list",
        method: "post",
    },


    GET_WEEKSTATEN_OVERVIEW: (queryString) => ({
        url: `weekstaten/overzicht?filter=${queryString}`,
        method: "get",
    }),

    GET_SCHOOL_LISTS: {
        url: "weekstaten/verwerken/get-school-lists",
        method: "post",
    },

    DOWNLOAD_REPORT: (id) => ({
        url: `document/${id}/weekstaat`,
        method: "get",
    }),
    
    GET_WEEKSTAAT_DATA: {
        url: "weekstaten/verwerken/get-weekly-list",
        method: "post",
    },
};


export const useCommunityData = (communityId) => {
    const api = API_ENDPOINT.COMMUNITY_DATA(communityId);
    return useApiFetcherSWR(api);
};



export const useSchoolList = (id) =>
    useApiFetcherSWR(
        id ? API_ENDPOINT.SCHOOL_LIST(id) : null
    );

export const useSaveWeekstaatSchools = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_WEEKSTAAT_SCHOOLS);

export const useGeneratePDF = (enabled = false) =>
    useApiFetcherSWR(
        enabled ? API_ENDPOINT.GENERATE_PDF : null
    );

export const useWeeklyScheduleList = () =>
    useApiFetcherSWR(API_ENDPOINT.WEEKLY_SCHEDULE_LIST);



export const useWeekstatenOverview = (queryString, config = {}) =>
    useApiFetcherSWR(
        queryString
            ? API_ENDPOINT.GET_WEEKSTATEN_OVERVIEW(queryString)
            : null,
        config
    );

export const useGetSchoolLists = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_SCHOOL_LISTS);


export const useDownloadWeekstaatReport = (id) =>
    useApiFetcherSWR(
        id ? API_ENDPOINT.DOWNLOAD_REPORT(id) : null
    );

export const useGetWeekstaatData = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_WEEKSTAAT_DATA);

export default API_ENDPOINT;